<template>
    <div :class="{'tab-area': true, online: sites.online}" ref="formContainer">
        <template v-if="!sites.online && sites.R_SITE_ID !== null">
            <h2>System offline</h2>
            <ul class="warning list-nums">
                <li>Launch C.Soft on your computer</li>
                <li>Check cable connection between computer and readers</li>
            </ul>
            <div class="information">
                <div class="line-group">
                    <div class="line">
                        <span class="name">Last successful connection time</span>: <span class="value">{{ sites.last_online | datetime('DD.MM.YYYY HH:mm') }}</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="sites.R_SITE_ID !== null">
            <h2>System online <span>and</span> ready for game</h2>
            <div class="information">
                <div class="line-group">
                    <div class="line">
                        <span class="name">Site ID</span>: <span class="value">{{ sites.R_SITE_ID }}</span>
                    </div>
                </div>
                <div class="line-group">
                    <div class="line">
                        <span class="name">Link to score monitor</span>:
                        <span class="value">
                          <a :href="sites.monitor" target="_blank">{{ sites.monitor }}</a>
                        </span>
                    </div>
                </div>
                <div class="line-group">
                    <div class="line">
                        <span class="name">Last successful connection time</span>: <span class="value">{{ sites.last_online | datetime('DD.MM.YYYY HH:mm') }}</span>
                    </div>
                    <div class="line">
                        <span class="name">Established connection form IP</span>: <span class="value">{{ sites.last_connection_ip }}</span>
                    </div>
                </div>
                <div class="line-group">
                    <div class="line">
                        <span class="name">Receiving settings for the Artifacts</span> – <span class="value">{{ sites.settings_get === 1 ? 'OK' : 'FALSE' }}</span>
                    </div>
                    <div class="line">
                        <span class="name">Settings saved to file</span> – <span class="value">{{ sites.settings_save === 1 ? 'OK' : 'FALSE' }}</span>
                    </div>
                </div>
            </div>
            <ul class="list-nums">
                <li v-for="reader in sites.readers" :key="'dashboard-readers-' + reader.R_READER_ID">
                    <span class="name">Artifact</span> –
                    <span v-if="reader.R_READER_STATUS === 1" class="value online">Online</span>
                    <span v-else class="value offline">Offline</span>
                </li>
            </ul>
        </template>
    </div>
</template>

<script>

    import {mapState} from 'vuex';

    export default {
        name: 'dashboard',

        data() {
            return {
                loader: null
            };
        },

        metaInfo() {
            return {
                title: 'System info - ' + (this.sites.online ? 'online' : 'offline'),
            }
        },

        components: {},
        mounted() {
            if (this.sites.R_SITE_ID === null) {
                this.$store.commit('showLoading', {container: this.$refs.formContainer});
            }
        },
        computed: {
            ...mapState(['sites'])
        },
        watch: {
            'sites.R_SITE_ID': function (newVal) {
                if (newVal !== null) {
                    this.$store.commit('hideLoading');
                }
            }
        }
    }
</script>
